import { Component, OnInit } from "@angular/core";
import { AdminDashboardService } from "src/app/services/admin-dashboard.service";
import { NotificationService } from "src/app/services/notification.service";
import { SideNavBarVisibilityService } from "src/app/services/side-nav-bar-visibility.service";
import { ThemeService } from "src/app/theme/theme-service.service";
import { ZPNotification } from "../../models/zpnotification";

@Component({
    selector: "app-refcodes",
    templateUrl: "./refcodes.component.html",
    styleUrls: ["./refcodes.component.scss"],
    standalone: false
})
export class RefcodesComponent implements OnInit {
  public list: any;
  public section = "refcodes";
  public item: any;
  public selectedItemCode;
  public disabled: boolean = false;
  checked: boolean;
  listOfRefcodes: any;
  page: any;
  totalPages: any;
  total: any;
  currentPage: number = 1;
  isDisabled: boolean = false;

  constructor(
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private api: AdminDashboardService,
    private notifications: NotificationService,
    public themeService: ThemeService
  ) {}

  async ngOnInit() {
    this.loadUsers(this.currentPage);
  }

  async loadUsers(page: number) {
    this.api.getList(this.section, page).then((allUsers) => {
      console.log("allUsers - ", allUsers);
      this.page = allUsers.page;
      this.totalPages = allUsers.pages;
      this.total = allUsers.total;
      this.list = allUsers.items;
      console.log("list: ", this.list);
    });
  }

  async saveItem(item) {
    const result = await this.api.putItem(this.section, item);
    if (result && result.success) {
      this.notifications.changeMessage(new ZPNotification("Item Saved"));
      this.toggleSection(item.code);
      this.loadUsers(this.page);
    } else {
      this.notifications.changeMessage(new ZPNotification("Save failed"));
    }
  }

  toggleSection(code) {
    console.log(code);
    if (this.selectedItemCode === code) {
      this.selectedItemCode = null;
    } else {
      this.selectedItemCode = code;
    }
    this.checkPlanHolderCounts(code);
  }

  addNew() {
    const newItem = {
      code: Math.random().toString(36).substring(8),
      instructions: { userType: "planHolder", funded: true },
    };
    this.list.push(newItem);
    this.selectedItemCode = newItem.code;
  }

  checkIfDirectInvoice(ev) {
    if (ev == true) {
      this.checked = true;
      this.disabled = true;
    } else {
      this.checked = false;
      this.disabled = false;
    }
  }

  async checkPlanHolderCounts(refCode) {
    console.log("checkPlanHolderCounts refCode - ", refCode);
    let planHolderCounts = await this.api.getPlanHoldersAccountsFromMfa(refCode);
    console.log('planHoldersCounts - ', planHolderCounts);
    if (planHolderCounts > 0) {
      this.isDisabled = true;
    }
  }
}
